








import { Component, Prop, Vue } from 'vue-property-decorator'
import { debounce } from 'lodash'

@Component
export default class OrganizationsTable extends Vue {
  @Prop()
  value: string

  query = ''

  created() {
    this.query = this.value
  }

  search() {
    this.$emit('input', this.query)
    this.$emit('search', this.query)
  }
}

